/* RESPONSIBLE TEAM: team-omni */
import ApplicationAdapter from './application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'facebook_integration';
  },
});
